module.exports = __webpack_public_path__ + "img/ar_earth_navigation.6eca3952.png";